<!-- form-group.component.html -->
<div [formGroup]="formGroup">
<fieldset>
	<legend>{{appName}}</legend>
	<div class="row">
	  <div class="col-md-4">
		<label class="form-label">{{appName}} application</label>
		<dx-text-box as-validator formControlName="description" class="form-control" type="text">
		</dx-text-box>
	  </div>
	  <div class="col-md-4">
		<label class="form-label">Custom function app description</label>
		<dx-text-box as-validator formControlName="selectedFunctionAppDescription" class="form-control" type="text" [value]="getSelectedItemName()">
		</dx-text-box>
	  </div>
	  <div class="col-md-4">
		<label class="form-label">Custom function app</label>
		<dx-select-box [items]="dataSource" showClearButton="true" as-validator formControlName="selectedFunctionApp" placeholder="None" class="form-control" valueExpr="id" displayExpr="name" [(value)]="selectedFunctionAppItemId">
		</dx-select-box>
	  </div>
	</div>
  </fieldset>
</div>
